import { render, staticRenderFns } from "./loyalty_progress.vue?vue&type=template&id=3468dc7a&"
import script from "./loyalty_progress.vue?vue&type=script&lang=js&"
export * from "./loyalty_progress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports